// extracted by mini-css-extract-plugin
export default {"footer":"svi6M"};